import React from 'react';
import { Modal as AntdModal } from 'antd';
import Button from './button';

const Modal = (props) => {
    const {
        open,
        setOpen,
        bodyStyle,
        width = 400,
        fullHeight,
        title,
        children,
        footer,
        onOk,
        okText
    } = props;

    return (
        <AntdModal
            destroyOnClose
            centered
            maskClosable={false}
            wrapClassName="modal"
            open={open}
            onCancel={() => setOpen('')}
            bodyStyle={{ height: fullHeight && 'calc(100vh - 100px)', ...bodyStyle }}
            width={width}
            title={title}
            footer={(footer === false || footer === null) ? null : (
                <div className="text-center">
                    {footer === '' ? (
                        <Button type="" onClick={() => setOpen('')}>關閉</Button>
                    ) : footer || (
                        <>
                            <Button type="" onClick={() => setOpen('')}>取消</Button>
                            <Button onClick={onOk}>{okText || '儲存'}</Button>
                        </>
                    )}
                </div>
            )}
        >
            {children}
        </AntdModal>
    );
};

export default Modal;
